import { Movil } from "./movil.model";
import { Gtp } from '../shared/gtp';

export class MovilMapa extends Movil {

    id? : any;
    geoinversa? : any;
    geoinversapol?: any;
    visible?: any;
    markerSource?: string;

    constructor(data: any, imgIcon?: string) {
        super();
        let gtp = new Gtp();
        let color = (data.ult_velocidad == 0) ? 'rojo' : 'verde';
        let ult_transmision = gtp.timeDiff(data.ult_fecha_hora, 'NOW');
        if (ult_transmision.hours>=12){ color = 'naranja'; }
        this.id = 'markerID_'+data.cod_equipo_rastreo;
        this.cod_equipo_rastreo = data.cod_equipo_rastreo;
        this.des_equipo_ratreo = data.des_equipo_ratreo;
        this.fecha_hora = data.ult_fecha_hora;

        // Validación de coordenadas
        this.latitud = parseFloat(data.ult_latitud);
        this.longitud = parseFloat(data.ult_longitud);

        // Verificar si las coordenadas son válidas
        if (isNaN(this.latitud) || isNaN(this.longitud) ||
            this.latitud === 0 || this.longitud === 0 ||
            this.latitud === null || this.longitud === null) {
            console.warn(`Móvil ${data.des_equipo_ratreo} (${data.cod_equipo_rastreo}) no tiene coordenadas válidas:`, {
                ult_latitud: data.ult_latitud,
                ult_longitud: data.ult_longitud,
                latitud_parsed: this.latitud,
                longitud_parsed: this.longitud,
                fecha_hora: data.ult_fecha_hora
            });
            // Marcamos como no visible si no tiene coordenadas válidas
            this.visible = false;
        } else {
            this.visible = true;
        }

        this.matricula = data.matricula;
        this.nro_vehiculo = data.nro_vehiculo;
        this.orientacion = data.ult_direccion;
        this.velocidad = data.ult_velocidad;
        this.geoinversa = data.geoinversa;
        this.geoinversapol = data.geoinversapol;
        this.color = color;
        let matricula = (data.matricula != "PROVISORIO") ? data.matricula : "PROVI"; //data.cod_equipo_rastreo.toString();
        this.label = (data.nombre) ? data.nombre : matricula;
        this.icono = this.mapIcon.getIcon(
            (imgIcon!=undefined) ? imgIcon : "auto",
            color,
            data.ult_direccion
        );
        this.markerSource = 'flota';
    }

}
